module.exports = __webpack_public_path__ + "0fe555b68d2ab94e12b0f4ba287e16ac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/helpers/images/thankYouImage/background-orange.svg
// module id = ./src/helpers/images/thankYouImage/background-orange.svg
// module chunks = 4